"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { CardsRoutedPage } from './deskUi/CardsRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function CardsSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={CardsRoutedPage} Loading={MsgDeskLoading} />
}
